import React, { useState } from 'react';
import { useSelector } from 'react-redux';
// import parse from 'html-react-parser';
import { RootState } from '@Redux/detail/store';
import { I_NoteList } from '@Redux/detail/Itineraries/interfaces';
import styles from './styles.module.scss';
import SlidePage from '@components/Common/SlidePage';
import { ArrowRight } from '@components/Common/Icons';
// import ArrowIcon from './imgs/arrowIcon';
import cN from 'classnames';

const ItineryTravelInfoM = () => {
    const { NoteList } = useSelector((store: RootState) => store.itinerariesReducer);
    const [openSidebarMenu, setOpenSidebarMenu] = useState(false);
    const [activeContent, setActiveContent] = useState({ CTitle: '', Desc: '' });

    const Item = ({ item }: { item: I_NoteList }) => {
        return (
            <div className={styles['item']} onClick={clickItem(item)}>
                <div className={styles['title']}>{item.CTitle}</div>
                <ArrowRight fill="#bbb" />
            </div>
        );
    };

    const clickItem = (item: I_NoteList) => () => {
        setOpenSidebarMenu(true);
        setActiveContent(item);
    };

    return (
        <>
            {NoteList.length > 0 && (
                <div className={styles['travelInfo_M']}>
                    {NoteList.map((item: I_NoteList, idx: string | number | null | undefined) => (
                        <Item item={item} key={idx} />
                    ))}
                </div>
            )}
            <SlidePage
                visible={openSidebarMenu}
                title={activeContent.CTitle}
                setIsVisible={() => setOpenSidebarMenu(false)}
            >
                <div dangerouslySetInnerHTML={{ __html: activeContent.Desc }} />
            </SlidePage>
        </>
    );
};

export default ItineryTravelInfoM;
